import { useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { demoClusterList } from '@cast/fixtures';
import { Cluster } from '@cast/types';

import { useIsSecurityDemoMode } from '@cast/infrastructure-demo';
import { useOrganizations } from '@cast/shared-organization-context-data-access';
import { enhanceCluster } from 'utils/api-utils';

import { useSecurityDataOrFixture } from './useSecurityDataOrFixture';

type UseClustersOrFixture = {
  clusters: Cluster[];
};

export const useClustersOrFixture = (
  clusterData: Cluster[]
): UseClustersOrFixture => {
  const { pathname } = useLocation();
  const match = pathname.startsWith('/organization/security');
  const { currentOrganization } = useOrganizations();

  const isSecurityDemoMode = useIsSecurityDemoMode();

  const clustersFixture = useMemo(
    () => () =>
      demoClusterList(currentOrganization!.id).then((data) => data.items),
    [currentOrganization]
  );

  let clustersOrFixture =
    useSecurityDataOrFixture(clusterData, clustersFixture) ?? [];

  if (match && isSecurityDemoMode) {
    clustersOrFixture = clustersOrFixture.map((cluster) =>
      enhanceCluster(cluster)
    );
  }

  return {
    clusters: clustersOrFixture,
  };
};
